import type { ListAvailableCrewMembersQuery } from '@/common/infrastructure/gql/generated/schema';

export type CrewMemberListItem = NonNullable<NonNullable<ListAvailableCrewMembersQuery['availableCrewMembers']>['items']>[number];

export function crewMemberHasJobRole(member: CrewMemberListItem | undefined, roleId: number | null): boolean {
  if (roleId == null) return false;
  return member?.jobRoles?.some((r) => r.id === roleId) ?? false;
}

export function crewFieldHasRoleMismatch(
  crew: { employeeId: number | null; roleId: number | null },
  crewMembers: CrewMemberListItem[] | null | undefined
): boolean {
  if (crew.employeeId == null || crew.roleId == null) return false;
  const member = crewMembers?.find((e) => e.id === crew.employeeId);
  if (!member) return false;
  return !crewMemberHasJobRole(member, crew.roleId);
}
